function path(root, subLink) {
  return `${root}${subLink}`;
}

const rootPath = "/";

export const paths = {
  root: rootPath,
  PositionListPage: path(rootPath, ""),
  EmailListPage: path(rootPath, "emailList"),
  evaluationScreen: path(rootPath, "evaluationScreen"),
  settings: path(rootPath, "settings"),
  interview: path(rootPath, "interview"),
  publicInterview: path(rootPath, "public-interview"),
  addPosition: path(rootPath, "addPosition"),
  templates: path(rootPath, "templates"),
  finishInterview: path(rootPath, "finish"),
  intevriewDetails: path(rootPath, "interviewDetails"),
};
